import gql from 'graphql-tag';
export default gql`
  query TableById($id: Int!) {
    tableById(id: $id) {
      id
      name
      json
      createdAt
      updatedAt
    }
  }
`;
